/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # User Order History functionality
define('modules/User/OrderHistory',[
    'jquery',
    'lodash',
    'moment',
    'global/all',
    'modules/Cart/all',
    'plugins/jquery-ui.min',
    'plugins/daterangepicker'
], function ($, _, moment, Roc, Cart) {
    'use strict';

    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    var pagination;
    var viewModel = {};

    var Selectors = {
        orderHistoryWrapper: '#mindHarborOrderHistoryContainer',
        ordersWrapper: '[data-roc-wrapper="ordersWrapper"]',
        orderDetailsBtn: '[data-roc-action="viewDetails"]',
        itemHistoryBtn: '[data-roc-action="viewItemHistory"]',
        itemHistoryDetailBtn: '[data-roc-action="viewItemHistoryDetail"]',
        itemQuickView: '[data-roc-action="openQuickView"]',
        searchBar: {
            searchPanel: '[data-roc-action="ordersSearchPanel"]',
            searchBtn: '[data-roc-action="ordersSearchBtn"]',
            status: '[data-roc-field="orderStatusSelect"]',
            dateRange: '[data-roc-field="orderDateRange"]',
            dateRangeLabel: '#daterangecontainer span',
            sortOrder: '[data-roc-field="sortOrderSelect"]',
            customerId: '[data-roc-field="customerIdSelect"]',
            shipTo: '[data-roc-field="shiptoSelect"]',
            filterNumbers: '[data-roc-field="orderNoMultipleFiltersInput"]'
        },
        wrappers: {
            dateRange: '[data-roc-wrapper="dateRange"]',
            accountName: '[data-roc-wrapper="accountName"]'
        },
        paging: {
            nextPage: '[data-roc-action="nextOrderPage"]',
            prevPage: '[data-roc-action="prevOrderPage"]',
            pageTextBox: '[data-roc-field="orderPageTextBox"]'
        },
        dynamic: {
            orderDetails: function (orderId) {
                return '#order-' + orderId + '-details';
            }
        }
    };

    var btns = {
        reOrder: '[data-roc-action="reOrder"]',
        viewOrderDetails: '[data-roc-action="viewDetails"]',
        approvePendingOrder: '[data-roc-action="approveOrder"]'
    };

    function getItemOrderNumber(element) {
        return $(element).closest('.item').attr('data-order-number');
    }

    function getItemOrderSuffix(element) {
        var suffix = $(element).closest('.item').attr('data-order-suffix');
        return suffix || '0';
    }

    function reOrder(cartId, orderNumber, orderSuffix, options) {
        options = options || {};
        $.proxyRequest({
            type: 'POST',
            url: '/api/store/cart/reorder',
            data: JSON.stringify({ orderId: cartId, orderNumer: orderNumber, orderSuffix: orderSuffix, currentOrderId: '{orderId}' }),
            contentType: 'application/json; charset=utf-8',
            beforeSend: options.beforeSend || null,
            serverCompleteAction: 'UpdateCurrentOrderId',
            complete: function (xhr) {
                if (xhr.responseText && !xhr.responseJSON) {
                    xhr.responseJSON = JSON.parse(xhr.responseText);
                }

                Roc.EventManager.notify(Roc.Events.cart.RE_ORDER, xhr);
                Roc.Logger.info(xhr);
            }
        });
        return false;
    };

    function reOrderEvt() {
        $(document).on('click', btns.reOrder, function () {
            var orderId = Roc.UI.getItemId(this);
            var orderNumber = getItemOrderNumber(this);
            var orderSuffix = getItemOrderSuffix(this);
            Roc.UI.confirm({
                "title": 'Re-Order',
                "message": 'Do you want your cart to be replaced with the available item(s)?',
                "buttons": {
                    "Continue": {
                        "class": 'btn btnAction re-order',
                        "autoClose": false,
                        "action": function () {
                            reOrder(orderId, orderNumber, orderSuffix, {
                                beforeSend: function () {
                                    Roc.Core.lockButton('.btn.btnAction.re-order');
                                }
                            });
                        }
                    },
                    "Cancel": {
                        "class": 'btn',
                        "action": function () { }
                    }
                }
            });
        });

        function filterOutMessagesForDisplay(response) {
            var errors = 0;
            if (response.messages > 0) {
                _.each(response.addCartItemsResponse, function (response) {
                    response.errors = _.filter(response.errors, function (e) {
                        return e.errorMessage !== 'Sorry, this item is no longer available.';
                    });

                    errors += response.errors.length;
                });
                response.messages = errors;
            }
            return errors === 0;
        }

        Roc.EventManager.bind(Roc.Events.cart.RE_ORDER, function (xhr) {
            var response = xhr.responseJSON || {};
            var redirectToCart = response.orderId && filterOutMessagesForDisplay(response);
            if (redirectToCart) {
                window.location.href = '/cart';
            } else {
                if (response.messages > 0) {
                    var model = {};

                    model.heading = response.cart ? 'Your cart have been loaded with problems:' :
                        'Problems occurred during your request and we were not able to load your cart.';
                    model.responses = response.addCartItemsResponse;

                    Roc.UI.template('serviceErrors-Tmp', model).then(function (renderedTemplate) {
                        $('#confirmBox').html(renderedTemplate);
                    });

                    $('#confirmButtons .btn.btnAction.re-order').remove();
                    $('#confirmButtons .btn').text('Continue');
                } else {
                    Roc.UI.ajaxErrorPopup(xhr, response.message);
                    Roc.Core.releaseLockedButton('.btn.btnAction.re-order');
                }
            }
        });
    }

    function openOrderDetailsEvt() {
        $(document).on('click', btns.viewOrderDetails, function () {
            var orderId = Roc.UI.getItemId(this);
            var targetSelector = $(this).attr('href');
            var url = apiUrl + '/api/order/' + orderId + '/';

            if (orderId == Roc.Enums.general.DEFAULT_GUID) {
                var orderNumber = getItemOrderNumber(this);
                var orderSuffix = getItemOrderSuffix(this);
                url = apiUrl + '/api/order/details/' + orderNumber + '/' + orderSuffix + '/';
            }

            if ($.trim($(targetSelector).text()).length === 0) {
                $.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json',
                    beforeSend: function () {
                        Roc.UI.block(targetSelector);
                    },
                    complete: function (xhr) {
                        Roc.Logger.info('OrderHistory -> openOrderDetailsEvt');
                        Roc.Logger.info(xhr);
                        var response = xhr.responseJSON || {};
                        if (xhr.status === 200) {
                            if (response && response.recipients) {
                                response.hasPickup = _.some(response.recipients,
                                    function (recipient) { return recipient.shippingMethodType === "StorePickup" });
                            }
                            Roc.UI.template('orderDetails-Tmp', response).then(function (renderedTemplate) {
                                $(targetSelector).html(renderedTemplate);
                            });
                        } else {
                            Roc.UI.Modal.alert('Failed to load order details');
                        }

                        Roc.UI.unblock(targetSelector);
                    }
                });
            }
            return false;
        });
    }

    function approvePendingOrderEvt() {
        $(document).on('click', btns.approvePendingOrder, function () {
            var orderId = Roc.UI.getItemId(this);
            var btnApprove = this;
            Roc.Core.lockButton(btnApprove);
            $.ajax({
                url: apiUrl + '/api/order/' + orderId + '/approve/',
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(Roc.UI.getItemId(this)),
                complete: function (xhr) {
                    Roc.Logger.info('OrderHistory -> approvePendingOrderEvt');
                    Roc.Logger.info(xhr);
                    if (xhr.status === 200) {
                        $('[data-id="' + orderId + '"] .status-label').text('Ordered');
                        $(btnApprove).remove();
                        Roc.UI.success('Completed!');
                    } else {
                        Roc.UI.ajaxErrorPopup(xhr);
                        Roc.Core.releaseLockedButton(btnApprove);
                    }
                }
            });

            return false;
        });
    }

    function bindInputDate() {
        $('.ui-datepicker-calendar').css('display', 'none');
        $('.ui-datepicker').datepicker({
            changeMonth: true,
            changeYear: true,
            showButtonPanel: true,
            minDate: new Date(2014, 1 - 1, 1),
            maxDate: new Date(),
            dateFormat: 'MM yy',
            onClose: function (dateText, inst) {
                $(this).datepicker('setDate', new Date(inst.selectedYear, inst.selectedMonth, 1));

                var date = new Date(inst.selectedYear, inst.selectedMonth, inst.selectedDay);
                $('#datepicker-value').val($.datepicker.formatDate('mm/dd/yy', date));
                $('#datepicker-value.roc-filter').trigger("change");
            }
        });
        $('.ui-datepicker').datepicker('setDate', new Date());
    }

    function updatePagination(data) {
        pagination = Roc.Pagination.updatePaging(data);
    }

    $(document).on('change', '#pageSize', function (e) {
        var pageSize = parseInt($('option:selected', this).val());
        updatePagination({ 'pageSize': pageSize });
        pagination.pageSize = pageSize;
        reloadWidget();
    });

    function initDateRangePicker(allowedPeriod) {
        var start = moment().subtract(6, 'months');
        var end = moment();
        var minDate = moment().subtract(allowedPeriod, 'years');

        $(Selectors.searchBar.dateRangeLabel).html("Last 6 Months");
        fillDateRangeInput(start, end);

        $('#daterangecontainer').daterangepicker({
            startDate: start,
            endDate: end,
            minDate: minDate,
            maxSpan: {
                'months': 6
            },
            ranges: {
                'Last 6 Months': [moment().subtract(6, 'months'), moment()],
                'Last 12 Months': [moment().subtract(12, 'months'), moment()],
                'Month to Date': [moment().startOf('month'), end]
            }
        }, function (start, end, label) {
            if (label && label !== "Custom Range") {
                $(Selectors.searchBar.dateRangeLabel).html(label);
            } else {
                $(Selectors.searchBar.dateRangeLabel).html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
            }
            fillDateRangeInput(start, end);
        });

    }

    function fillDateRangeInput(start, end) {
        $(Selectors.searchBar.dateRange).val(start.format('MM-DD-YYYY') + ' - ' + end.format('MM-DD-YYYY'));
    }

    function bindEvents() {
        openOrderDetailsEvt();
        reOrderEvt();
        approvePendingOrderEvt();
        bindInputDate();
        searchEvt();
    }

    function loadOrders(data) {
        Roc.UI.template('orderHistory-Tmp', data).then(function (renderedTemplate) {
            $('#order-history').replaceWith(renderedTemplate);
        });

        if (data.orders.length > 0) {
            Roc.UI.template('pager-Tmp', data.pagination).then(function (renderedTemplate) {
                $('#order-history').prepend(renderedTemplate);
            });
            pagination = Roc.Pagination.updatePaging(data);
        }
    }

    function reloadWidget(pg) {
        pg = pg || pagination;
        var filterNumbers = $(Selectors.searchBar.filterNumbers).val();
        pg.filterNumbers = filterNumbers;
        var dateRangeVal = $(Selectors.searchBar.dateRange).val();
        var startDate;
        var endDate;
        if (dateRangeVal) {
            var dates = dateRangeVal.split(" - ");
            startDate = dates[0];
            endDate = dates[1];
        }
        pg.startDate = startDate;
        pg.endDate = endDate;
        pg.status = $(Selectors.searchBar.status).val();
        pg.sortBy = $(Selectors.searchBar.sortOrder).val();

        $.ajax({
            url: apiUrl + '/api/order/history/model/',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(pg),
            complete: function (xhr) {
                Roc.Logger.info('OrderHistory -> reloadWidget');
                Roc.Logger.info(xhr);
                if (xhr.status === 200) {
                    var response = xhr.responseJSON || {}
                    loadOrders(response);
                } else {
                    Roc.UI.ajaxErrorPopup(xhr);
                }
            }
        });
    }

    function searchEvt() {
        $(document)
            .off('click', Selectors.searchBar.searchBtn)
            .on('click',
                Selectors.searchBar.searchBtn,
                function () {
                    reloadWidget();
                });
    }

    function init(model) {
        viewModel = model;
        viewModel.emptyResultsSelector = '#noOrdersMsg';
        viewModel.orderListSelector = '#order-history';
        initDateRangePicker(2);
        if (viewModel.pagination) {
            pagination = Roc.Pagination.init({
                page: viewModel.pagination.page,
                pageSize: viewModel.pagination.pageSize,
                totalPages: viewModel.pagination.totalPages,
                prefix: '#order-history-wrapper'
            }, reloadWidget);
        }
        loadOrders(viewModel);
        bindEvents();
    };

    var OrderHistory = {
        init: init,
        viewModel: viewModel
    };

    Roc.Logger.debug('OrderHistory.js Loaded:', OrderHistory);

    return OrderHistory;
});
